<div class="tipps-slider" #slider>
  <div class="slide-track" #slideTrack>
    @for (tipp of tipps; track tipp; let i = $index) {
      <div class="slide" id="slide-{{i}}">
        <div class="grid-x grid-padding-x">
          <div class="cell text-center medium-4">
            @if (tipp.icon) {
              <i class="icon-{{tipp.icon}}"></i>
            }
          </div>
          <div class="cell medium-8">
            <h3 [innerHTML]="textPrefix + '.' + tipp.name + '.headline' | translate: placeholder"></h3>
            <p  [innerHTML]="textPrefix + '.' + tipp.name + '.text' | translate: placeholder"></p>
          </div>
          @if (!hideButton && tipp.url) {
            <div class="cell cta-wrapper" >
              <a class="button inline-arrow-right" role="button" [href]="tipp.url" target="_blank" [innerHTML]="textPrefix + '.' + tipp.name + '.button' | translate: placeholder"></a>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <button (click)="prev()" class="slider-nav slider-nav-prev" [title]="textPrefix + '.navigation.prev' | translate: placeholder"><i class="icon-chevron-left"></i></button>
  <button (click)="next()" class="slider-nav slider-nav-next" [title]="textPrefix + '.navigation.next' | translate: placeholder"><i class="icon-chevron-right"></i></button>
  <ul class="slider-bubbles">
    @for (tipp of tipps; track tipp; let i = $index) {
      <li [class.active]="currentSlide === i"></li>
    }
  </ul>

</div>
